import * as React from 'react'
import { DateRangePickerSeeker } from 'ui-seeker/core'
import { isBefore } from 'ui-seeker/utils'

export default function DateLaterRangeSelect({...props}) {

	const myProps = {
		disabledDate: date => isBefore(date), 
		...props
	}

    return <DateRangePickerSeeker {...myProps} />
}